import React from 'react';
import PropTypes from 'prop-types';

// ************************************************************************************
// This React component is a simple wrapper that serves as a modal. 
//
// Inputs: 
//    showCustomModal - which is passed in by the parent, to indicate whether to open
//       or close the  modal
//    children - this prop is used to pass in the content you want to show when the modal
//       appears. The can be a combintation of text and buttons, and/or optional a cancel 
//       button.
//
// Process: When you pass "true" via the showCustomModal prop, the modal will display
//    on the page. When you pass in "false", it will close the modal. The styles are
//    what controls the positioning on the page and adds a backround over the existing 
//    screen, effectively blocking everything behind the modal.
// 
// It is recommended that child component be a separate component.
// ************************************************************************************
const CustomModal = ({ showCustomModal, children }) =>  {

    return  (
      <div>
        {showCustomModal && (
          <div className="custom-modal">
              <div className="custom-modal-content">
                {children}
              </div>
          </div>
        )}
      </div>
    ) 
}

CustomModal.propTypes = {
  showCustomModal:      PropTypes.bool.isRequired,     /* flag to indicate when to show modal */
};


export default CustomModal;




// WEBPACK FOOTER //
// ./src/components/modals/CustomModal.js